import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { isEmpty } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography } from '@material-ui/core';
import { loadTexts } from '../../../../config/texts';

import { PieChart } from '../../components';
import { HorizontalBar } from 'react-chartjs-2';
import { getPopularCourses } from '../../selectors';

const TEXT_KEY = 'dashboard';

const PopularCoursesCard = ({ data: { labels, data }, locale }) => {
  const texts = loadTexts(TEXT_KEY, locale);
  const graphData = {
    labels,
    datasets: [
    {
      label: texts.labels.top_courses,
      backgroundColor: 'rgba(84,84,178,0.4)',
      borderColor: 'rgb(84,84,178)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(84,84,178,0.4)',
      hoverBorderColor: 'rgb(84,84,178)',
      data
    }
  ]
  }
  return (
    <Paper>
      {isEmpty(data) ? (
        <Typography>
          {texts.fields.no_popular_courses}
        </Typography>
      ) : (
        <HorizontalBar data={graphData} />
        // <PieChart title="Top 10 Popular Courses" labels={labels} data={data} />
      )}
    </Paper>
)};

PopularCoursesCard.propTypes = {
  data: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  data: getPopularCourses(state),
  locale: state.appState.locale,
});

export default compose(
  withStyles(() => ({}), { name: 'PopularCoursesCard' }),
  connect(mapStateToProps),
)(PopularCoursesCard);



// WEBPACK FOOTER //
// ./src/modules/dashboard/cards/PopularCoursesCard/index.js